<div
  class="notifications-dropdown position-relative"
  (baseClickOutside)="close()"
>
  <div (click)="toggle()">
    <i
      class="fa-solid fa-bell notifications-icon"
      [ngbTooltip]="'notification.plural' | translate"
    ></i>
    <div
      *ngIf="totalUnreadNotifications > 0"
      class="notifications-dot"
    ></div>
  </div>

  <div
    class="notifications-dropdown-content px-4"
    *ngIf="isOpen"
    (click)="close()"
  >
    <base-notifications-dropdown
      [totalUnreadNotifications]="totalUnreadNotifications"
      [unreadNotifications]="unreadNotifications"
      [allNotifications]="allNotifications"
      [pagination]="pagination"
      [modalRef]="modalRef"
      (notificationClick)="notificationClick($event)"
    ></base-notifications-dropdown>
  </div>
</div>

<ng-template #notificationsPopup>
  <base-notifications-modal
    [modalRef]="modalRef"
    [activeNotificationId]="activeNotificationId"
    [pagination]="pagination"
    [allNotifications]="allNotifications"
    [allNotificationsRead]="totalUnreadNotifications === 0"
  ></base-notifications-modal>
</ng-template>
